import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/bank-statements')({
  staticData: { crumb: 'bankStatements' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'treasury.read'),
  component: Outlet,
})
